import {
  Badge,
  Grid,
  Status,
  TextWeight,
  theme
} from '@focaldata/cin-ui-components'
import React from 'react'
import { ProjectType } from '../../../data/gql-gen/dashboard/graphql'
import {
  checkIsConfirmationPage,
  checkIsFDChatResultsPage,
  checkIsResultsPage
} from '../../../utils/HelperFunctions'
import {
  isMultiMarketProjectType,
  projectTypeMap,
  statusMap,
  stringStatusMap
} from '../../../utils/projectUtils'
import { EditableProjectTitle } from './EditableProjectTitle'
import useStyles from './ProjectNameAndStatus.styles'

interface Props {
  projectName: string | undefined
  projectStatus: string
  projectType: ProjectType
  // Without it the title is read-only — see EditableProjectTitle.
  projectId?: string
}

const ProjectTitleAndStatus: React.FC<Props> = (props: Props) => {
  const { projectName, projectStatus, projectType, projectId } = props

  const isConfirmationPage = checkIsConfirmationPage()
  const isResultsPage = checkIsResultsPage()
  const isMultiMarket = isMultiMarketProjectType(projectType)
  const isFDChatResultsPage = checkIsFDChatResultsPage()

  const { classes } = useStyles({
    styleProps: { isConfirmationPage, isResultsPage, isFDChatResultsPage }
  })

  const badgeStatus =
    (isMultiMarket ? Status.LIVE : statusMap.get(projectStatus)) ?? Status.DRAFT

  const badgeLabel =
    (isMultiMarket
      ? projectTypeMap.get(projectType)
      : stringStatusMap.get(badgeStatus)) || 'Unknown'

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      className={classes.rootFullWidth}
    >
      <Grid item className={classes.projectName}>
        <EditableProjectTitle
          name={projectName ?? ''}
          projectId={projectId}
          weight={TextWeight.SemiBold}
          noWrap
        />
      </Grid>
      <Badge
        label={badgeLabel}
        status={badgeStatus}
        style={{ marginRight: theme.spacing(1) }}
      />
    </Grid>
  )
}

export default ProjectTitleAndStatus
